import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/api';
import { ClipLoader } from 'react-spinners';
import '../../styles/Auth.css';

const StaffLogin = () => {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]             = useState('');
  const [pendingApproval, setPendingApproval] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  // Show pending banner if redirected back from a protected route
  useEffect(() => {
    if (location.state?.pendingApproval) {
      setPendingApproval(true);
    }
  }, [location.state]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setPendingApproval(false);
    setLoading(true);
    try {
      const res = await authService.login(email, password, 'staff');
      const { user, token } = res.data;
      login(user, token);
      // Bulk-imported user: tempPassword matched → needsPasswordChange=true.
      // Navigate to dashboard so ActivationModal (globally mounted) can intercept.
      if (user.needsPasswordChange) {
        navigate('/staff/dashboard');
      } else if (user.status !== 'Pending') {
        navigate('/staff/dashboard');
      }
      // else: self-registered Pending user → stay on page, show pendingApproval banner
    } catch (err) {
      const data = err.response?.data;
      if (data?.pendingApproval) {
        setPendingApproval(true);
      } else {
        setError(data?.message || 'Login failed. Please check your credentials.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-background d-flex align-items-center justify-content-center min-vh-100">
      <Link to="/login" className="back-btn-circle"><i className="fas fa-arrow-left" /></Link>

      <div className="form-glass-container p-4 p-md-5">
        <div className="text-center mb-4">
          <img
            src="https://res.cloudinary.com/dnby5o1lt/image/upload/v1754489527/ALUMINI_CONNECT_LOGO_hwlrpw.png"
            width="45" alt="MAMCET"
          />
          <h2 className="login-title mt-2">Staff Login</h2>
          <p className="text-muted small">Coordinators, HODs &amp; Faculty</p>
        </div>

        {pendingApproval && (
          <div className="alert py-2 small mb-3" role="alert"
            style={{ background: '#fff8e1', border: '1px solid #ffc107', color: '#856404', borderRadius: 8 }}>
            <i className="fas fa-clock me-2" />
            <strong>Pending Approval.</strong> Your account is awaiting admin review.
            You'll receive an email once it's activated.
          </div>
        )}
        {error && (
          <div className="alert alert-danger py-2 small mb-3" role="alert">
            <i className="fas fa-exclamation-circle me-2" />{error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Official Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="you@mamcet.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <button
            type="submit"
            className="btn-mamcet-red d-flex align-items-center justify-content-center gap-2 w-100"
            disabled={loading}
          >
            {loading ? <><ClipLoader size={16} color="#fff" /> Logging in...</> : 'Login'}
          </button>
          <div className="auth-footer-text text-center text-muted mt-3">
            New staff member? <Link to="/signup/staff" className="text-decoration-none fw-bold" style={{ color: '#c84022' }}>Register Here</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StaffLogin;
